import { Component, ViewEncapsulation, AfterContentChecked, ElementRef, ViewChild, Input } from '@angular/core';
import { FindHomeSearchResult } from '../../models/search/find-home-search-result';
import { UntypedFormControl } from '@angular/forms';
import { Dropdown } from '../../models/dropdown/dropdown';
import { Address } from '../../models/address/address';
import { RoomPreview } from '../../models/property/room-preview';
import { SearchService } from '../../services/search.service';
import { DropdownService } from '../../services/dropdown.service';
import { tap, filter, debounceTime, switchMap } from 'rxjs/operators';

@Component({
    selector: 'find-home-search',
    templateUrl: './find-home-search.component.html',
    encapsulation: ViewEncapsulation.None
})

export class FindHomeSearchComponent implements AfterContentChecked  {
    @Input() placeholder: string = 'Search cities, towns, areas...';
    searchResult: FindHomeSearchResult;
    query: UntypedFormControl = new UntypedFormControl('');
    @ViewChild('dropdown') dropdown: ElementRef;
    dropdownItem: Dropdown;

    noResults: boolean = false;
    finishedResults: boolean = false;
    searchingResults: boolean = false;
    searchResults: FindHomeSearchResult = new FindHomeSearchResult();
    areaResults: Address[] = [];
    roomResults: RoomPreview[] = [];
    searchResultsVisible: boolean = false;
    searchInputMobileVisible: boolean = false;

    constructor(private searchService: SearchService, private dropdownService: DropdownService) {
        this.dropdownItem = new Dropdown(this.dropdown, () => this.searchResultsVisible = false);
    }

    ngOnInit() {
        this.resetSearchResults();

        this.query.valueChanges
        .pipe(
            tap((query: string) => {
                this.noResults = false;
                this.finishedResults = false;
                this.searchingResults = true;
                this.resetSearchResults();

                if (query.length <= 2) {
                    this.searchingResults = false;
                    this.searchResultsVisible = false;
                }
            }),
            filter(value => value.length > 2),
            debounceTime(500),
            switchMap((query: string) => {
                this.searchingResults = true;
                this.searchResultsVisible = true;

                return this.searchService.findHomeSearch(query);
            })
            )
            .subscribe((data: FindHomeSearchResult) => this.searchSuccess(data),
                error => this.searchFailed(error));
    }

    resetSearchResults() {
        this.searchResults = new FindHomeSearchResult();
        this.searchResults.majorAddresses = [];
        this.searchResults.minorAddresses = [];
        this.searchResults.roomPreviews = [];
    }

    focusInput() {
        if (this.query.value.length > 2) {
            this.searchResultsVisible = true;
        }
        else {
            this.searchResultsVisible = false;
        }
    }

    searchSuccess(data: FindHomeSearchResult) {
        this.searchResults = data;

        if (data.majorAddresses.length + data.minorAddresses.length + data.roomPreviews.length === 0) {
            this.noResults = true;
        }
        else {
            this.noResults = false;
        }

        this.searchingResults = false;
        this.finishedResults = true;
        this.searchResultsVisible = true;
    }

    public searchFailed(error: Error): void {
        console.log(error);

        this.searchingResults = false;
        this.noResults = true;
        this.finishedResults = true;
        this.resetSearchResults();
        this.searchResultsVisible = true;
    }

    toggleSearchInputMoble() {
        this.searchInputMobileVisible = !this.searchInputMobileVisible;
    }

    clickLink() {
        this.searchResultsVisible = false;
        this.query.setValue('');
    }

    ngAfterContentChecked(): void {
        this.dropdownItem.component = this.dropdown;
        this.dropdownService.addCallback(this.dropdownItem);

    }

    ngOnDestroy(): void {
        this.dropdownService.removeCallback(this.dropdownItem);
    }

}
